import type { FC } from "react";

import BoxTitle from "pro-features/components/BoxTitle/src/BoxTitle";
import { NO_DATA_SIGN } from "app/filters/const";
import { normalizeForMinValue } from "app/pages/website-analysis/traffic-sources/search/common/utils";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

import {
    DataDescription,
    DataRowContainer,
    DataRowTitle,
    DataRowValue,
    DataTitle,
    DataValue,
} from "./styledComponents";

interface ISimpleValueRow {
    field: string;
    displayName: string;
    tooltip?: string;
    displayNoData?: boolean;
    filter?: (value: number) => string;
}

interface ISimpleValueData {
    value: number | string;
    description?: string;
}

interface ISimpleValueCellTemplate {
    data: ISimpleValueData;
    row: ISimpleValueRow;
}

export const SimpleValueCellTemplate: FC<ISimpleValueCellTemplate> = ({ data, row }) => {
    const { field, displayName, tooltip, filter, displayNoData } = row;
    const { value, description } = data[field];
    let valueToDisplay: string | number;
    if (!value && displayNoData) {
        valueToDisplay = NO_DATA_SIGN;
    } else {
        valueToDisplay = typeof value === "number" && filter ? filter(normalizeForMinValue(value)) : value;
    }

    return (
        <DataRowContainer>
            <BoxTitle
                Container={DataRowTitle}
                tooltip={tooltip}
            >
                <DataTitle>{displayName}</DataTitle>
            </BoxTitle>
            <FlexColumn
                justifyContent="center"
                alignItems="flex-end"
            >
                <DataRowValue>
                    <DataValue>{valueToDisplay}</DataValue>
                </DataRowValue>
                {description ? <DataDescription>{description}</DataDescription> : null}
            </FlexColumn>
        </DataRowContainer>
    );
};
